<template>

  <generic-card
      :byContent="true"

      @click="$emit('click')"
      @delete="$emit('deletePayment')"
  >
    <template #content>
      <content-bank-transaction
          :bankTransaction="bankTransaction"
          :isParentMethodPriority="true"
          :isPayable="isPayable"
          :isViewable="isViewable"
          :isDeletable="false"
          :is-selected="isSelected"
          :display-bank-account="displayBankAccount"
          @view="$emit('view')"
          @pay="$emit('pay')"
      />
    </template>

  </generic-card>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'

import GenericCard from './Card'
import ContentBankTransaction from './components/BankTransaction'

export default {
  components: {
    GenericCard,
    ContentBankTransaction
  },
  props: {
    bankTransaction: {
      type: Object,
      default: () => {}
    },
    isViewable: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: false
    },
    isPayable: {
      type: Boolean,
      default: false
    },
    isDeletable: {
      type: Boolean,
      default: true
    },
    isParentMethodPriority: {
      type: Boolean,
      default: false
    },
    displayBankAccount: {
      type: Boolean,
      default: false
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components

      // Data

      // Computed

      // Methods
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>